import { useEffect, useRef, useState } from "react";
import type { ChannelActivityPage } from "./domain/channelActivity";
import { useReOS } from "./domain/store";

export function useChannelPhotoStatus(accountID?: string, operationID?: string) {
  const store = useReOS(); const latest = useRef(store); latest.current = store;
  const [page, setPage] = useState<ChannelActivityPage>();
  useEffect(() => {
    let active = true; let timer: number | undefined;
    setPage(undefined);
    async function refresh() {
      if (!accountID || latest.current.persistenceMode !== "api") return;
      try {
        const next = await latest.current.channelRequest<ChannelActivityPage>(accountID, "activity");
        if (!active) return;
        setPage(next);
      } catch { if (active) timer = window.setTimeout(refresh, 5000); }
    }
    void refresh();
    return () => { active = false; window.clearTimeout(timer); };
  }, [accountID, operationID]);
  return page && operationID ? { ...page, photoJobs: store.database.channelPhotoJobs?.filter((job) => job.marketplaceAccountID === accountID) ?? page.photoJobs } : page;
}

export function ImportPhotoStatus({ accountID, operationID, itemIDs }: { accountID?: string; operationID: string; itemIDs?: string[] }) {
  const page = useChannelPhotoStatus(accountID, operationID);
  const jobs = page?.photoJobs.filter((job) => job.operationID === operationID && (!itemIDs || itemIDs.includes(job.itemID))) ?? [];
  if (!accountID || !page?.enabled.importPhotos || !jobs.length) return null;
  const saving = jobs.some((job) => ["queued", "saving"].includes(job.status));
  const attention = jobs.some((job) => ["partial", "failed", "cancelled"].includes(job.status));
  const saved = jobs.flatMap((job) => job.entries).filter((entry) => ["saved", "duplicate"].includes(entry.status)).length;
  return <p className="marketplace-import-photo-status" role="status">
    {saving ? "Saving listing photos. You can leave this page." : attention ? "Some photos need attention." : `${saved} ${saved === 1 ? "photo" : "photos"} saved.`}{" "}
    <a href={`/channels?channelActivity=${encodeURIComponent(accountID)}&activityTab=photos`}>{saving ? "View progress" : attention ? "Review photos" : "View photo imports"}</a>
  </p>;
}
